import React from "react";
import { Medal, Award, Trophy, Gem } from "lucide-react";

export function tierFor(points) {
  const p = Math.round(points || 0);
  if (p <= 20) return "Bronze";
  if (p <= 40) return "Silver";
  if (p <= 60) return "Gold";
  if (p <= 80) return "Platinum";
  return "Diamond";
}

export const TIER_STYLES = {
  Bronze:   { bg: "bg-amber-50",   text: "text-amber-800",  border: "border-amber-400",  icon: Medal  },
  Silver:   { bg: "bg-slate-100",  text: "text-slate-800",  border: "border-slate-400",  icon: Medal  },
  Gold:     { bg: "bg-yellow-50",  text: "text-yellow-900", border: "border-yellow-500", icon: Award  },
  Platinum: { bg: "bg-sky-50",     text: "text-sky-900",    border: "border-sky-500",    icon: Trophy },
  Diamond:  { bg: "bg-indigo-50",  text: "text-indigo-900", border: "border-indigo-500", icon: Gem    },
};

export default function TierBadge({ points = 0, tier, size = "sm", showPoints = true, testId, className = "" }) {
  const t = tier || tierFor(points);
  const s = TIER_STYLES[t] || TIER_STYLES.Silver;
  const Icon = s.icon;
  const lg = size === "lg";
  return (
    <span
      data-testid={testId || `tier-badge-${t.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 rounded-full border-2 font-semibold ${s.bg} ${s.text} ${s.border} ${lg ? "px-3 py-1.5 text-base" : "px-2.5 py-1 text-xs"} ${className}`}
      aria-label={`Access grade ${t}, ${Math.round(points || 0)} out of 100`}
    >
      <Icon className={lg ? "w-5 h-5" : "w-3.5 h-3.5"} aria-hidden="true" />
      <span>{t}</span>
      {showPoints && (
        <span className={`font-normal opacity-80 ${lg ? "text-sm" : "text-[10px]"}`}>
          {Math.round(points || 0)}/100
        </span>
      )}
    </span>
  );
}
